import React from 'react'
import PropTypes from 'prop-types'
import { Editor as PlainTextEditor } from 'draft-js'
import classNames from 'classnames/bind'
import RichTextEditor from '../../sitewide/RichTextEditor'
import AIAssistantButton from '../../sitewide/RichTextEditor/StyleControls/AIAssistant/AIAssistantButton'
import styles from './MessageEditor.css'

const cx = classNames.bind(styles)

const MessageEditor = ({
  messages,
  blockRendererFn,
  bodyState,
  hideImgPicker,
  isBlastEmail,
  isEmail,
  placeholder,
  plugins,
  handleTemplateSelection,
  updateBodyState,
  openOptionsModal,
  optionsModalOpen,
  openCreateTemplateModal,
  createModalOpen,
  closeOptionsModal,
  templateSettings,
  practiceName
}) => (
  <div>
    {isEmail ? (
      <RichTextEditor
        messages={messages}
        openCreateTemplateModal={openCreateTemplateModal}
        createModalOpen={createModalOpen}
        blockRendererFn={blockRendererFn}
        editorState={bodyState}
        hideImgPicker={hideImgPicker}
        isBlastEmail={isBlastEmail}
        isEmail={isEmail}
        placeholder={placeholder}
        plugins={plugins}
        handleTemplateSelection={handleTemplateSelection}
        showExtraButtons={isBlastEmail}
        updateBodyState={updateBodyState}
        openOptionsModal={openOptionsModal}
        optionsModalOpen={optionsModalOpen}
        closeOptionsModal={closeOptionsModal}
        templateSettings={templateSettings}
        practiceName={practiceName}
      />
    ) : (
      <div style={{ position: 'relative', minHeight: '40px', overflow: 'visible' }}>
        {["Shirck Orthodontics", "Feathered Smiles Orthodontics"].includes(practiceName) &&
        <div className={cx('aiButtonContainer')}>
          <AIAssistantButton
            messages={messages}
            editorState={bodyState}
            updateParentBodyState={updateBodyState}
          />
          </div>
        }
        <PlainTextEditor
          plugins={plugins}
          editorState={bodyState}
          onChange={updateBodyState}
          placeholder={placeholder}
          style={{ paddingTop: '40px' }}
        />
      </div>
    )}
  </div>
)

MessageEditor.propTypes = {
  blockRendererFn: PropTypes.func,
  bodyState: PropTypes.shape({
    _immutable: PropTypes.object,
  }),
  isBlastEmail: PropTypes.bool,
  isEmail: PropTypes.bool,
  hideImgPicker: PropTypes.bool,
  placeholder: PropTypes.string.isRequired,
  plugins: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        blockRendererFn: PropTypes.func,
        decorator: PropTypes.arrayOf(
          PropTypes.shape({
            component: PropTypes.func,
            strategy: PropTypes.func,
          }),
        ),
        initialize: PropTypes.func,
      }),
    ),
  ),
  updateBodyState: PropTypes.func.isRequired,
}

export default MessageEditor



// WEBPACK FOOTER //
// ./src/components/Messages/MessagesEditor/MessageEditor.js